<div class="layout-footer">
  <footer class="footer text-white pt-5 pb-2 position-relative">
    <div class="container">
      <div class="row justify-content-between align-items-start">
        <!-- Logo -->
        <div class="col-lg-5 col-xl-6 mb-5 gap-3 text-center text-lg-start">
          <img src="public/logo/Hilbertechfooter.svg" alt="logo" />
        </div>

        <div class="col-lg-7 col-xl-6 ms-auto">
          <div class="row justify-content-between">
            <!-- Services -->
            <div class="col-md-2 col-lg-4 mb-4 text-center text-md-start">
              <h6 class="mb-4">{{ "FooterDetails.services" | translate }}</h6>
              <ul class="list-unstyled services">
                <li>
                  <a class="text-grey text-decoration-none">{{
                    "FooterDetails.webDevelopment" | translate
                  }}</a>
                </li>
                <li>
                  <a class="text-grey text-decoration-none">{{
                    "FooterDetails.itConsulting" | translate
                  }}</a>
                </li>
                <li>
                  <a class="text-grey text-decoration-none">{{
                    "FooterDetails.integration" | translate
                  }}</a>
                </li>
              </ul>
            </div>

            <!-- Company -->
            <div class="col-md-2 col-lg-3 mb-4 text-center text-md-start">
              <h6 class="mb-4">{{ "FooterDetails.company" | translate }}</h6>
              <ul class="list-unstyled">
                <li>
                  <a routerLink="/about" class="text-grey text-decoration-none">
                    {{ "FooterDetails.AboutUs" | translate }}
                  </a>
                </li>
                <li>
                  <a
                    class="text-grey text-decoration-none"
                    routerLink="/careers"
                    >{{ "FooterDetails.career" | translate }}</a
                  >
                </li>
              </ul>
            </div>

            <!-- Contact -->
            <div class="col-md-2 col-lg-3 mb-4 text-center text-md-start">
              <h6 class="mb-4">{{ "FooterDetails.ContactUs" | translate }}</h6>

              <p>
                <a
                  href="mailto:contact@hilbertech.com"
                  class="mb-3 text-grey text-decoration-none d-flex justify-content-center justify-content-lg-start gap-2"
                  ><i class="bi bi-envelope"></i> contact&#64;hilbertech.com</a
                >
              </p>
            </div>

            <div class="col-lg-1 text-end w-10 p-3 mt-4">
              <app-back-to-top></app-back-to-top>
            </div>
          </div>
        </div>
      </div>

      <!-- Bottom -->
      <div
        class="d-flex justify-content-between mt-4 pt-3 border-top border-light"
      >
        <p class="">&copy; 2025 Hilbertech. All rights reserved.</p>
        <a
          href="https://www.linkedin.com/company/hilbertech/"
          target="_blank"
          class="text-grey text-decoration-none"
          ><i class="bi bi-linkedin"></i
        ></a>
      </div>
    </div>
  </footer>
</div>
